import { useNavigate } from "react-router-dom";
import Aside from "../../../components/Aside";
import CustomDataTable from "../../../components/CustomDataTable";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { useEffect, useMemo, useState } from "react";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { MetaService } from "../../../services/MetaService";
import Button from "../../../components/form-controls/Button";
import { AlertService } from "../../../services/Alert";
import SetMediaModal from "./SetMediaModal";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
function TemplatesPage() {

    const { t } = useTranslation();
    const { call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();
    const navigate = useNavigate(); 
    
    const [rows, setRows] = useState([])
    const [isSync, setIsSync] = useState(false)
    const [modalMedia, setModalMedia] = useState({
        show: false,
        template: null
    })

    const columns = useMemo(() => [
        {
            name: t("platform.channels.templates.name"),
            sortable: true,
            with: 30,
            selector: row => {

                return (
                    <>
                        <h5 className="h5 text-inherit">{row.name}</h5>        
                        <p>{row.language}</p>
                    </>
                )
            },
        },
        {
            name: t("platform.channels.templates.status"),
            sortable: true,
            with: 30,
            center: true,
            selector: row => {
                switch (row.status) {
                    case 'APPROVED':
                        return <span className="badge bg-soft-info text-info"><span className="legend-indicator bg-info"></span> {row.status} </span>
                    case 'REJECTED':
                    case 'DELETED':
                        return <span className="badge bg-soft-danger text-danger"><span className="legend-indicator bg-danger"></span> {row.status} </span>
                
                    default:
                        return <span className="badge bg-soft-dark text-dark"><span className="legend-indicator bg-dark"></span> {row.status} </span>
                }
            },
        },
        {
            name: t("platform.channels.templates.category_name"),
            sortable: true,
            with: 30,
            selector: row => {

                return (
                    <>
                        <p className="mb-0">{row.category}</p>
                    </>
                )
            },
        },
        {
            name: t("platform.channels.templates.preview"),
            sortable: true,
            // with: 30,
            selector: row => {

                const template = JSON.parse(row.body);
                const header = template.find( t => t.type === 'HEADER')
                const body = template.find( t => t.type === 'BODY')
                const footer = template.find( t => t.type === 'FOOTER')
                const buttons = template.find( t => t.type === 'BUTTONS')

                return (
                    <div className="preview-template inline my-3">
                        { header && header.format === 'TEXT' &&  <div className="preview-template-header">{header.text}</div> }
                        { header && header.format === 'IMAGE' &&  (
                            <div className="preview-template-header">
                                <div className="preview-template-image" style={{ backgroundImage: `url(${header.image})`}}>
                                    { !header.image && <i className="bi-card-image"></i> }
                                </div>
                                { !header.image && <span className="badge bg-soft-danger text-danger">Sin imagen</span> }
                            </div>
                        ) }
                        { header && header.format === 'VIDEO' &&  (
                            <div className="preview-template-header">
                                <div className="preview-template-video" > 
                                    
                                    { !header.video && <i className="bi-play-circle-fill"></i> }
                                    { header.video && <video > <source src={header.video} /> </video>}
                                </div> 
                                { !header.video && <span className="badge bg-soft-danger text-danger">Sin video</span> }
                                { header.video && <a href={header.video} target="_blank" rel="noreferrer"><span className="badge bg-soft-primary text-primary">Da clic aquí para visualizar video</span></a> }
                            </div>
                        ) }
                        { header && header.format === 'DOCUMENT' &&  (
                            <div className="preview-template-header"> 
                                <div className="preview-template-video" > 
                                    <i className="bi-filetype-pdf"></i>
                                </div> 
                                { !header.document && <span className="badge bg-soft-danger text-danger">Sin PDF</span> }
                                { header.document && <a href={header.document} target="_blank" rel="noreferrer"><span className="badge bg-soft-primary text-primary">Da clic aquí para visualizar archivo</span></a> }
                            </div>
                        ) }
                        <div dangerouslySetInnerHTML={{__html: body.text.replace(/\n/g, '<br/>') }}></div>
                        {footer && <div className="preview-template-footer">{footer.text}</div>}

                        {
                            buttons && (
                                <div className="d-flex">
                                    {
                                        buttons.buttons.map( (btn, index) => (<div key={index} className="preview-template preview-template-btn inline">{btn.text}</div>))
                                    }
                                </div>
                            )
                        } 
                    </div>
                )
            },
        },
        {
            name: t("platform.channels.templates.actions"),
            sortable: false,
            // with: 30,
            cell: (row) => {
                const template = JSON.parse(row.body);
                const header = template.find( t => t.type === 'HEADER')

                return (
                    <div className="btn-group" role="group">
                        <button className="btn btn-white btn-sm" onClick={() => deleteTemplate(row)}>
                            <i className="bi-trash-fill"></i> Borrar
                        </button>

                        {
                            row.status === 'APPROVED' && header && header.format !== 'TEXT' && (
                                <div className="btn-group">
                                    <button type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                        <button
                                            className="dropdown-item"
                                            onClick={() => changeMedia(row) }
                                        >
                                            Cambiar media
                                        </button>
                                    </div>
                                </div>
                            )
                        }

                        
                    </div>
                )
            }
        }
        
    ], []);

    const syncTemplates = async() => {
        setIsSync(true)
        await MetaService.syncTemplates(account.id)
        await getTemplates();
        setIsSync(false)

        AlertService.toastSuccess('Se actualizarón correctamente las plantillas.')
    }

    const handleSetMedia = async(refresh) => {
        if(refresh) {
            await getTemplates();
        }
        
        setModalMedia({ show: false, template: null })
    }

    const deleteTemplate = async(template) => {

        await AlertService.warning('Aviso', '¿Estás seguro de querer borrar esta plantilla?. Esta acción no se puede deshacer.', async () => {
            try {

                await MetaService.delete(account.id, template.id, template.meta_id, template.name)
                await getTemplates()

                AlertService.toastSuccess('Se Elimino correctamente la plantilla.')
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', error || 'Ocurrió un error al eliminar la plantilla, intenta nuevamente')
            }
        });

    }
    
    const changeMedia = async(template) => {
        setModalMedia({
            show: true,
            template
        })
    }

    const getTemplates = async() => {
        const { data } = await call (() => MetaService.getTemplates(account.id));
        setRows(data)
    }

    useEffect(() => {
        getTemplates()
    }, [])
    

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Plataforma</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Canales</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">WhatsApp Business</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">

                                <button type="button" className="btn btn-soft-primary btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>

                                <h2 className="page-header-title m-0 me-3 text-dark">Plantillas de mensajes</h2>
                            </div>

                            <div className="col-sm-auto">
                                <Button className="btn btn-soft-primary btn-sm me-3" isLoading={isSync} onClick={syncTemplates}><i className="bi-arrow-repeat me-2"></i> {t("platform.channels.templates.btn-upload")} </Button>
                                <button className="btn btn-primary btn-sm" onClick={() => navigate('/channels/templates/create-template')}><i className="bi-plus-lg"></i> {t("platform.channels.templates.btn-create")} </button>
                            </div>
                        </div>

                    </div>


                    <CustomDataTable
                        columns={columns}
                        data={rows}
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.body}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.language}`.match(new RegExp(`${term}`, 'i')) 
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>


            <SetMediaModal state={modalMedia} onRequestClose={(refresh) => handleSetMedia(refresh)}  />

        </>
    )
}
export default TemplatesPage